import React from "react"

export const FourOhFour = () => {
   return (
      <>
         <h1 className="text-white text-center">No No No...this is not the page bruh!!!</h1>
      </>
   )
};